import { createContext, useContext } from "react";

const PageContext = createContext();

export const PageProvider = ({ children }) => {
  return <PageContext.Provider value={{}}>{children}</PageContext.Provider>;
};

export const usePageProvider = () => {
  return useContext(PageContext);
};
